import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Phone, MapPin } from 'lucide-react';
import EcosystemProductsSection from './EcosystemProductsSection';

const Footer = () => {
    const { t } = useTranslation();

    const footerLinks = {
        [t('footer.products')]: [
            { name: t('nav.how_it_works'), href: '/how-it-works' },
            { name: t('footer.pricing'), href: '/hoister#plans' },
        ],
        [t('footer.company')]: [
            { name: t('nav.about'), href: '/about' },
            { name: t('nav.contact'), href: '/contact' },
            { name: t('footer.privacy'), href: '/privacy' },
            { name: t('footer.terms'), href: '/terms' },
        ],
    };



    return (
        <footer className="relative bg-dark-card/50 border-t border-dark-border">
            {/* Gradient Line */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-primary to-transparent" />

            <div className="container-custom py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
                    {/* Brand Section */}
                    <div className="lg:col-span-2">
                        <Link to="/" className="flex items-center space-x-3 mb-4 group">
                            <img
                                src="/logo.png"
                                alt="NetVid Logo"
                                className="w-16 h-16 object-contain transition-transform duration-300 group-hover:scale-110"
                            />
                            <span className="text-2xl font-bold font-display text-primary">
                                NetVid
                            </span>
                        </Link>
                        <p className="text-light-muted mb-6 max-w-sm">
                            {t('footer.tagline')}
                        </p>

                        {/* Contact Details */}
                        <div className="space-y-3 mb-6">
                            <div className="flex items-center text-light-muted font-medium">
                                <Phone className="w-5 h-5 mr-3 text-primary" />
                                <a href="tel:+918977555077" className="hover:text-primary transition-colors">
                                    +91-8977555077
                                </a>
                            </div>
                            <div className="flex items-start text-light-muted">
                                <MapPin className="w-5 h-5 mr-3 text-primary mt-1 flex-shrink-0" />
                                <span className="text-sm">
                                    {t('footer.address')}
                                </span>
                            </div>
                        </div>


                    </div>

                    {/* Links Sections */}
                    {Object.entries(footerLinks).map(([category, links]) => (
                        <div key={category}>
                            <h3 className="text-light font-bold mb-6 tracking-wide uppercase text-sm">{category}</h3>
                            <ul className="space-y-4">
                                {links.map((link) => (
                                    <li key={link.name}>
                                        <Link
                                            to={link.href}
                                            className="text-light-muted hover:text-primary transition-colors duration-300 text-sm"
                                        >
                                            {link.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <EcosystemProductsSection />

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-dark-border">
                    <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
                        <div className="flex flex-col items-center md:items-start space-y-2">
                            <p className="text-light-muted text-xs">
                                © 2026 NetVid. {t('footer.rights')}
                            </p>
                            <p className="text-light-muted text-xs flex items-center">
                                <span className="mr-2">🇮🇳</span>
                                {t('footer.made_in_india')}
                            </p>
                        </div>
                        <div className="flex items-center space-x-8 text-xs font-medium">
                            <Link to="/privacy" className="text-light-muted hover:text-primary transition-colors">
                                {t('footer.privacy')}
                            </Link>
                            <Link to="/terms" className="text-light-muted hover:text-primary transition-colors">
                                {t('footer.terms')}
                            </Link>
                            <Link to="/cookies" className="text-light-muted hover:text-primary transition-colors">
                                {t('footer.cookies')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
